<p8-settings-page>
  <p8-settings-header [titlePath]="['Documents']">
    <div *ngIf="! selectingMode">
      <button mat-raised-button color="accent" [routerLink]="['new']"
              matTooltip="ajouter des documents à la bibliothèque">
        AJOUTER DOCUMENTS
      </button>
    </div>

    <div *ngIf="selectingMode">
      <button mat-raised-button color="accent" (click)="openAddModaleDocument()"
              matTooltip="ajouter des documents à la bibliothèque">
        AJOUTER DOCUMENTS
      </button>
    </div>
  </p8-settings-header>

  <app-data-table
    [dataSource]="dsDocuments"
    [extraParams]="extraParams"
    [filterDisplay]="true"
    [placeHolderFilter]="'Rechercher un document'"
    [toolTipFilter]="'Rechercher un document'"
    [flexAction]="5" [flexColumn]="90"
    [pageSize]="maxItems" [pageSizesList]="[5,10,25]"
    [columns]="columns" [actions]="actions"
    [showLoader]="true"
    class="p8-cm_data-table__search-full-width"
  >
  </app-data-table>

</p8-settings-page>

